import { ChemicalComponent } from "@/services/chemical-component"
import { Button, Col, Form, InputNumber, Row, Space } from "antd"
import { useEffect } from "react"
import styles from "./styles.module.less";
import { FunctionOutlined } from "@ant-design/icons"
import classNames from "classnames"


export const AntoineForm = (props: {
  component?: ChemicalComponent.Modal,
  onSave: (val) => void
  onCancel?: Function
}) => {
  const {onSave, onCancel, component}= props
  const [form] = Form.useForm()

  useEffect(() => {
    if (component) {
      form.setFieldsValue(component.ant5)
    }
  }, [component, form])
  
  return <Form
    form={form}
    onFinish={(values) => {
      onSave({ant5: values})
    }}
    className="mt-4"
  >
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='a5'
          label='A'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='b5'
          label='B'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='c5'
          label='C'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='d5'
          label='D'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='e5'
          label='E'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      <Form.Item
          name='f5'
          label='F'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='tmin'
          label='Tmin(K)'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
      <Col span={12}>
      <Form.Item
          name='tmax'
          label='Tmax(K)'
          rules={[{required: true}]}
        >
          <InputNumber style={{width: '100%'}} />
        </Form.Item>
      </Col>
    </Row>

    <div className={classNames('flex-start', styles.tip)}>
      <div>
        <FunctionOutlined style={{fontSize: 24}} />
      </div>
      <div className="ml-1">
        <div>Vapor pressure is calculated according to the following Antoine-equation formulation:
          <br /><span>ln(P) =  A+B/(T+C)+D.ln(T)+E.T^F</span>（with P in kPa and T in K）</div>
      </div>
    </div>

    <Row justify={'end'} className="mt-2">
      <Space>
        <Button htmlType="button" onClick={() => onCancel?.()}>Cancel</Button>
        <Button type="primary" htmlType="submit">Save</Button>
      </Space>
    </Row>
    
  </Form>
}